import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import RadioButton from '../refund-radio-button';
import ImgCartMessageCancel from '../../../../images/cart-cancel.png';
import cx from 'classnames';
import Pictogram from '../pictogram';
import RefundLoader from './refund-loader';
import TranslatedCopy from '../../../intl/translated-copy';
import PropTypes from 'prop-types';

export const PaymentOptions = ({
  handleOptionSelected,
  loader,
  toggleRadioBtnChange,
}) => {
  const [selectedOption, setSelectedOption] = useState();
  const [awSelected, setAwSelected] = useState(false);
  const [cardSelected, setCardSelected] = useState(false);

  const AWOptionClasses = cx({
    'PaymentOptions-refundAction': true,
    'PaymentOptions-refundAction--selected': selectedOption === 'AW',
  });

  const CardOptionClasses = cx({
    'PaymentOptions-refundAction': true,
    'PaymentOptions-refundAction--selected': selectedOption === 'card',
  });

  useEffect(() => {
    toggleRadioBtnChange(!awSelected && !cardSelected);
    if (awSelected) {
      handleOptionSelected('AW');
    } else if (cardSelected) {
      handleOptionSelected('Card');
    }
  }, [awSelected, cardSelected]);

  const handleOptionChange = (option) => {
    setSelectedOption(option);
  };

  const handleRadioAw = () => {
    setAwSelected(true);
    setCardSelected(false);
  };

  const handleRadioCard = () => {
    setAwSelected(false);
    setCardSelected(true);
  };

  return (
    <div className='PaymentOptions'>
      { !loader ?
        <section className='PaymentOptions-container'>
          <button className='PaymentOptions-container-backBtn'>
            <Pictogram className='PaymentOptions-container-backBtn--logo' id='BackButtonLogo' />
            <TranslatedCopy
              className='PaymentOptions-container-backBtn--text'
              copyID='CC_FO_HEADER_BACK'
            />
          </button>
          <TranslatedCopy
            className='PaymentOptions-container--optionsHeader'
            copyID='MYB_REFUND_OPTIONS'
            tagName='h2'
          />
          <div className='PaymentOptions-container-form'>
            <div
              className={ AWOptionClasses }
              onClick={ () => handleRadioAw() }
              role='radio'
            >
              <label className='PaymentOptions-refundAction-optionsCard'>
                <RadioButton
                  className='form-check-input'
                  isActive={ awSelected }
                  onClick={ () => handleOptionChange('AW') } />
                <div>
                  <TranslatedCopy
                    className='PaymentOptions-refundAction-optionsCard--refundOption'
                    copyID='R&P_AEROWALLET_TITLE'
                    tagName='h3'
                  />
                  <TranslatedCopy
                    className='PaymentOptions-refundAction-optionsCard--label'
                    copyID='MYB_REFUND_TO_OWNER'
                    tagName='p'
                  />
                </div>
                <div className='PaymentOptions-refundAction-badge'>
                  <TranslatedCopy copyID='MYB_IMMEDIATE' />
                </div>
                <div className='PaymentOptions-refundAction-optionsCard--paymentIcon'>
                  <Pictogram id='Aerowallet' />
                </div>
              </label>
            </div>
            <div className={ CardOptionClasses }
              role='radio' onClick={ () => handleRadioCard() } >
              <label className='PaymentOptions-refundAction-optionsCard'>
                <RadioButton
                  className='form-check-input'
                  isActive={ cardSelected }
                  onClick={ () => handleOptionChange('card') } />
                <div>
                  <h3 className='PaymentOptions-refundAction-optionsCard--refundOption'>
                    <TranslatedCopy
                      card_info='****1234'
                      copyID='MYB_CARD_INFO'
                    />
                  </h3>
                  <TranslatedCopy
                    className='PaymentOptions-refundAction-optionsCard--label'
                    copyID='MYB_AVAILABLE_DAYS'
                    tagName='p'
                  />
                </div>
                <div className='PaymentOptions-refundAction-optionsCard--paymentIcon'>
                  <Pictogram id='Mastercard' />
                </div>
              </label>
            </div>
          </div>
          <div className='PaymentOptions-container-changeFlightSection'>
            <Pictogram className='PaymentOptions-container-changeFlightSection--changeFlightIcon' id='ChangeFlightIcon' />
            <TranslatedCopy
              className='PaymentOptions-container-changeFlightSection--changeFlightText'
              copyID='MYB_CHANGE_FLIGHT_OPTION'
              tagName='p'
            />
          </div>
        </section>
        :
        <RefundLoader />
      }
      <div className='PaymentOptions-cart'>
        <img
          alt='Cart empty'
          className='ShoppingCartSection-img'
          src={ ImgCartMessageCancel } />
        <h3 className='ShoppingCartSection-message-title'>
          <TranslatedCopy copyID='CC_EMPTYCART_HOME_TITLE' />
        </h3>
        <p className='ShoppingCartSection-message-text'>
          <TranslatedCopy copyID='MYB_REFUND_BREAKDOWN' />
        </p>
      </div>
    </div>
  );
};

PaymentOptions.propTypes = {
  handleOptionSelected: PropTypes.func,
  loader: PropTypes.bool,
  toggleRadioBtnChange: PropTypes.func,
};

const mapStateToProps = (state) => ({
  country: state.LanguageBundle.country,
  language: state.Manage.language,
});

export default connect(mapStateToProps)(PaymentOptions);
